import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  Typography,
  TableSortLabel,
  IconButton,
  TableBody,
  TableRow,
  Button,
  Menu,
  MenuItem,
  Checkbox,
  ListItemText,
  CardMedia,
  ListItem,
  List,
  Avatar,
  ListItemIcon,
  Divider,
  Paper,
} from "@mui/material";
import Images from "../../../assets/images";
import Colors from "../../../assets/styles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import {
  AccountBalanceWallet,
  Language,
  FileCopy,
  ShoppingCart,
  Settings,
} from "@mui/icons-material";
import { get } from "../../../api";
import axios from "axios";
import OrderServices from "../../../api/orderServices/order.index";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import {

  CategoryScale,
  LinearScale,
  BarElement,
  Title,


} from 'chart.js';
import { Bar, Doughnut } from 'react-chartjs-2';
import GroupIcon from '@mui/icons-material/Group';
import { useAuth } from "../../../context";
import { useNavigate } from "react-router-dom";

ChartJS.register(ArcElement, Tooltip, Legend);
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const tableHead = [
  {
    name: "country",
    label: "COUNTRY",
    sortOrder: { column: "country", direction: "asc" },
    visible: true,
  },
  {
    name: "sales",
    label: "SALES",
    sortOrder: { column: "sales", direction: "asc" },
    visible: true,
  },
  {
    name: "value",
    label: "VALUE",
    sortOrder: { column: "value", direction: "asc" },
    visible: true,
  },
  {
    name: "bounce",
    label: "BOUNCE",
    sortOrder: { column: "bounce", direction: "asc" },
    visible: true,
  },
];

const tableBody = [
  {
    country: "USA",
    sales: "15%",
    value: 2,
    bounce: 0.2,
  },
  {
    country: "CA",
    sales: "12%",
    value: 3,
    bounce: 0.2,
  },
  {
    country: "UAE",
    sales: "22%",
    value: 5,
    bounce: 1.2,
  },
  {
    country: "BRA",
    sales: "10%",
    value: 8,
    bounce: 0.1,
  },
  {
    country: "MOR",
    sales: "25%",
    value: 4,
    bounce: 2.2,
  },
];


const tableHead2 = [
  {
    name: "id",
    label: "ID",
    visible: true,
    sortOrder: { column: "id", direction: "asc" },
  },
  {
    name: "title",
    label: "Title",
    visible: true,
    sortOrder: { column: "title", direction: "asc" },
  },
  {
    name: "description",
    label: "Description",
    visible: true,
    sortOrder: { column: "description", direction: "asc" },
  },
  {
    name: "category",
    label: "Category",
    visible: true,
    sortOrder: { column: "category", direction: "asc" },
  },
  {
    name: "price",
    label: "Price",
    visible: true,
    sortOrder: { column: "price", direction: "asc" },
  },
  {
    name: "discountPercentage",
    label: "Discounted Price",
    visible: true,
    sortOrder: { column: "discountPercentage", direction: "asc" },
  },
  {
    name: "rating",
    label: "Rating",
    visible: true,
    sortOrder: { column: "rating", direction: "asc" },
  },
  {
    name: "stock",
    label: "Stock",
    visible: true,
    sortOrder: { column: "stock", direction: "asc" },
  },
  {
    name: "tags",
    label: "Tags",
    visible: true,
    sortOrder: { column: "tags", direction: "asc" },
  },
  {
    name: "sku",
    label: "SKU",
    visible: true,
    sortOrder: { column: "sku", direction: "asc" },
  },
  {
    name: "weight",
    label: "Weight",
    visible: true,
    sortOrder: { column: "weight", direction: "asc" },
  },
  {
    name: "dimensions",
    label: "Dimensions",
    visible: true,
    sortOrder: { column: "dimensions", direction: "asc" },
  },
  {
    name: "warrantyInformation",
    label: "Warranty Information",
    visible: true,
    sortOrder: { column: "warrantyInformation", direction: "asc" },
  },
  {
    name: "shippingInformation",
    label: "Shipping Information",
    visible: true,
    sortOrder: { column: "shippingInformation", direction: "asc" },
  },
  {
    name: "availabilityStatus",
    label: "Availability Status",
    visible: true,
    sortOrder: { column: "availabilityStatus", direction: "asc" },
  },
  {
    name: "returnPolicy",
    label: "Return Policy",
    visible: true,
    sortOrder: { column: "returnPolicy", direction: "asc" },
  },
  {
    name: "minimumOrderQuantity",
    label: "Minimum Order Quantity",
    visible: true,
    sortOrder: { column: "minimumOrderQuantity", direction: "asc" },
  },
  {
    name: "reviews",
    label: "Reviews",
    visible: true,
    sortOrder: { column: "reviews", direction: "asc" },
  },
  {
    name: "thumbnail",
    label: "Thumbnail",
    visible: true,
    sortOrder: { column: "thumbnail", direction: "asc" },
  },
  {
    name: "meta",
    label: "Meta",
    visible: true,
    sortOrder: { column: "meta", direction: "asc" },
  },
];

const ITEM_HEIGHT = 48;

function Dashboard() {
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [anchor, setAnchor] = useState(null);
  const [stats, setStats] = useState(null);
  const navigate = useNavigate()
  const { user } = useAuth();



  const handleToggleColumn = (column) => {
    setColumns((prevColumns) =>
      prevColumns.map((col) =>
        col.name === column ? { ...col, visible: !col.visible } : col
      )
    );
  };


  const handleSettingsClick = (event) => {
    setAnchor(event.currentTarget);
  };
  const data = {
    labels: ['Generation','Designs'],
    datasets: [
      {

        data: [Math.ceil(stats?.generationToDesignConversionRate), 100 - Math.ceil(stats?.generationToDesignConversionRate)],
        backgroundColor: [
          'rgb(255, 99, 132)',
          'rgba(187, 186, 186, 1)',

        ],
        borderColor: [
          'rgb(255, 99, 132)',

        ],
        borderWidth: 1,
      },
    ],
  };


  const oldlabels = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  
  const currentMonthIndex = new Date().getMonth(); // Get current month index (0-based)
  const startMonthIndex = (currentMonthIndex + 1) % 12; // Shift dynamically
  
  const labels = [...oldlabels.slice(startMonthIndex), ...oldlabels.slice(0, startMonthIndex)];
  
  console.log(labels);
  const data2 = {
    labels,
    datasets: [
      {
        label: 'Generations',
        data: stats?.graph?.images,
        backgroundColor: 'rgb(75, 192, 192)',
      },
      {
        label: 'User Registrations',
        data: stats?.graph?.customers,
        backgroundColor: 'rgb(255, 99, 132)',
      },

    ],
  };

  const options = {
    plugins: {
      title: {
        display: true,
        text: 'User Registration vs Image Generations',
      },
    },
    responsive: true,
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
      },
    },
  };

  const handleSettingsClose = () => {
    setAnchor(null);
  };
  const StatCard = ({ icon, color, label, value }) => {
    return (
      <Paper
        elevation={3}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: '90%',
          height: 150,
          padding: 2,
          boxShadow: "rgba(0, 0, 0, 0.02) 0px 3.5px 5.5px",
        }}
      >
        <Typography
          variant={"body2"}
          sx={{ color: Colors.grey, fontWeight: 700 }}
        >
          {label}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          {React.cloneElement(icon, { sx: { fontSize: 40, color } })}
        </Box>

        <Typography variant="h6" fontWeight="bold">
          {value}
        </Typography>
      </Paper>
    );
  };
  const getAll = async () => {
    try {
      const { data } = await axios.get("https://dummyjson.com/products");
      console.log(data);
      const tableHead = Object.keys(data.products[0]).map((key) => ({
        name: key,
        label: key.toUpperCase(),
        sortOrder: { column: "country", direction: "asc" },
        visible: true,
      }));

      const tableBody = data.products.map((item) => {
        let obj = {};
        tableHead.forEach((value) => {
          obj[value.name] =
            typeof item[value.name] === "object"
              ? JSON.stringify(item[value.name])
              : item[value.name];
        });
        obj.visible = true;
        // console.log("🚀 ~ tableBody ~ obj:", obj);
        return obj;
      });

      setColumns(tableHead);
      setRows(tableBody);
    } catch (e) {
      console.log(e);
    }
  };

  const getStats = async () => {
    try {

      const { data } = await OrderServices.getStats()

      console.log(data);
      setStats(data)


    } catch (error) {
      console.log(error);
    } finally {

    }
  }

  const cardData = [
    {
      title: "Total Customers",
      value: stats?.customersTotal,
      thisMonth: stats?.customersThisMonth,
      lastMonth: stats?.customersLastMonth,
      icon: <GroupIcon />,
    },
    {
      title: "Total Generations",
      value: stats?.generationsTotal,
      thisMonth: stats?.generationsThisMonth,
      lastMonth: stats?.generationsLastMonth,
      icon: <AutoFixHighIcon />,
    },
    {
      title: "Designs",
      value: stats?.designsTotal,
      thisMonth: stats?.designsThisMonth,
      lastMonth: stats?.designsLastMonth,
      icon: <FileCopy />,
    },

  ];
  useEffect(() => {
    if(user?._id == '62d51755c36b03fe4a429083'){
      navigate('/blogs')
    }
    else{

      getStats()
      getAll();
    }
  }, []);

  return (
    <Box>
      {stats && <Grid container>
        <Grid
          item
          xs={12}
          md={12}
          sx={{
            mt: 13,
            pl: 2,
          }}
        >
          <Grid container rowGap={"18px"}>
            <Grid item xs={12} md={10}>
              <Typography
                sx={{
                  fontSize: { xs: "24px", md: "30px" },
                  fontWeight: 700,
                  pl: 2,
                  fontFamily: "Maven Pro, sans-serif",
                  color: "#0f172a",
                }}
              >
                 Statistics
              </Typography>
            </Grid>
            
            <Grid item xs={12} md={11} sx={{ position: 'relative' }}>
              {/* Background GIF */}
              {/* <Box
                sx={{
                  position: 'absolute',
                  zIndex: 1, // Lower zIndex to be behind content
                  top: 0,
                  right: 0,
                  width: '500px',
                  height: '500px',
                  backgroundImage: `url(${Images.globe3d})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  backgroundPosition: 'center'
                  // opacity: 0.2, // Adjust opacity if needed for better visibility
                }}
              /> */}

              {/* Foreground content */}
              <Grid container spacing={2} sx={{ position: 'relative', zIndex: 10 }}>
                {cardData.map((item, ind) => (
                  <Grid item xs={12} sm={12} md={4} lg={4} key={ind}>
                    <Box
                      sx={{
                        p: 3,
                        background: Colors.white,
                        borderRadius: "15px",
                        height: '90px',
                        boxShadow: "rgba(0, 0, 0, 0.02) 0px 3.5px 5.5px",
                      }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Box sx={{ width: "100%" }}>
                          <Typography
                            variant={"body2"}
                            sx={{ color: Colors.grey, fontWeight: 700 }}
                          >
                            {item.title}
                          </Typography>
                          <Typography sx={{ fontSize: "18px", fontWeight: 600 }}>
                            {item.value}
                          </Typography>
                        </Box>
                        {React.cloneElement(item.icon, {
                          sx: {
                            fontSize: "22px",
                            borderRadius: "12px",
                            p: "10px",
                            backgroundColor: Colors.secondary,
                            color: Colors.white,
                          },
                        })}
                      </Box>
                      { <Divider sx={{ my: "12px", borderColor: Colors.secondary }} />}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center"
                        }}>
                        { (
                          <Box sx={{ display: "flex", gap: "3px" }}>
                            <Typography variant="h6" sx={{ color: Colors.grey, fontWeight: 700, fontSize: '12px' }}>
                              This Month :
                            </Typography>
                            <Typography variant="body1" sx={{ color: 'black', fontWeight: 700, fontSize: '12px' }}>
                              {item?.thisMonth}
                            </Typography>
                          </Box>
                        )}
                        { (
                          <Box sx={{ display: "flex", gap: "3px" }}>
                            <Typography variant="h6" sx={{ color: Colors.grey, fontWeight: 700, fontSize: '12px' }}>
                              Last Month :
                            </Typography>
                            <Typography variant="body1" sx={{ color: 'black', fontWeight: 700, fontSize: '12px' }}>
                              {item?.lastMonth}
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </Grid>
                ))}
                <Grid item xs={8}>
                  <Grid container xs={12} spacing={2} justifyContent={'space-between'}>
                  <Grid item md={6} lg={6} >

                    <StatCard
                      icon={<GroupIcon />}
                      color="#0BD1D1"
                      label={'Repeated Users'}
                      value={stats?.repeatCustomers[0]?.repeatCustomers}
                    />

                  </Grid>
                  <Grid item md={6} lg={6} >

                    <StatCard
                      icon={<AutoFixHighIcon />}
                      color="#0BD1D1"
                      label={'Average Generation Per User'}
                      value={Math.ceil(stats?.avgGenerationsPerUser)}
                    />

                  </Grid>
                  <Grid item md={11.5} lg={11.5} >
                  <Box sx={{
                    width: '100%',
                    background: Colors.white,
                    borderRadius: "15px",
                    p: 2,

                    boxShadow: "rgba(0, 0, 0, 0.02) 0px 3.5px 5.5px",
                  }} >
                    <Bar options={options} style={{ width: '100%', height: '100%' }} data={data2} />
                  </Box>

                </Grid>
                  </Grid>
                </Grid>


                <Grid item md={4} lg={4} >

                  <Box sx={{
                    width: '100%',
                    background: Colors.white,
                    borderRadius: "15px",
                    p: 2,

                    boxShadow: "rgba(0, 0, 0, 0.02) 0px 3.5px 5.5px",
                  }} >
                    <Typography
                      variant={"body2"}
                      sx={{ color: Colors.grey, fontWeight: 700, p: 2 }}
                    >
                      Generation To Design Conversion Rate
                    </Typography>
                    <Typography sx={{ fontSize: "18px", fontWeight: 600, textAlign: 'center' }}>
                      {Math.ceil(stats?.generationToDesignConversionRate)}%
                    </Typography>
                    <Doughnut style={{ width: '100%', height: '100%' }} data={data} />
                  </Box>

                </Grid>
              

              </Grid>
              
            </Grid>

          </Grid>
        </Grid>

      </Grid>}
    </Box>
  );
}

export default Dashboard;
